export function getAdIdFromElement(element?: Element): string {
    const ad = element?.closest(".js-snippet");
    return ad?.getAttribute("data-idanuncio") || "";
}